// import PropTypes from 'prop-types';
import { PureComponent, useCallback } from 'react';

import './RangeSlider.style';
import React from "react";
import 'react-rangeslider/lib/index.css';
import 'react-rangeslider/umd/rangeslider';
import 'react-rangeslider/umd/rangeslider.min.css';
import MultiRangeSlider from "multi-range-slider-react";
import { setQueryParams } from '@scandipwa/scandipwa/src/util/Url';
import history from '@scandipwa/scandipwa/src/util/History';

export class RangeSlider extends PureComponent {
    static propTypes = {
        attributevalue: this.propTypes,
        option: this.propTypes,
        handleOptionClick: this.propTypess,
        label: this.propTypess,
        labels: this.propTypess,
        min: this.propTypess,
        max: this.propTypess,
        minValue: this.propTypess,
        maxValue: this.propTypess,
        step: this.propTypes,
        className: this.propTypes,
        oninput: this.propTypes,
        onChange: this.propTypes
    };

    handleChangeOptions = (attributevalue, option, e) => {
        // console.log(e);
        this.props?.onChange ? this.props?.onChange(e) : "";
    };

    onchanegeinput = (e) => {
        this.props?.oninput ? this.props?.oninput(e) : "";
    }

    render() {
        const {
            attributevalue,
            option,
            label,
            labels,
            max,
            min,
            maxValue,
            minValue,
            step,
            className,
        } = this.props;

        return (
            <div className="RangeSlider">
                <div className='slider orientation-reversed color-container'>
                    <div className='slider-group'>
                        <div className='slider-horizontal'>
                            <MultiRangeSlider
                                min={min}
                                max={max}
                                minValue={minValue}
                                maxValue={maxValue}
                                step={step}
                                labels={label ? labels : ""}
                                ruler={label ? true : false}
                                onInput={(e) => {
                                    this.onchanegeinput(e);
                                }}
                                onChange={(e) => {
                                    this.handleChangeOptions(attributevalue, option, e);
                                }}
                                className={className}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RangeSlider;
